import { Button, Card, CloseButton, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import QRCode from 'react-qr-code'
import { faCircleXmark, faClose } from '@fortawesome/free-solid-svg-icons';

const ARPlayer = ({url, setArplayer}) => {
    // console.log("Url", url)
    return (
        <>
            <Card id="overlays" className=' border-0 rounded-0 p-1 m-1'>
            {/* <Button variant=''  onClick={() => setArplayer(null)} className='align-self-end bg-transparent border-0 btn-tertiary p-1' ><FontAwesomeIcon icon={faCircleXmark} size='xl' className=' text-danger bg-white rounded-circle border-0 red-close-button' /> </Button> */}
            <CloseButton  onClick={() => setArplayer(null)} className='align-self-end bg-white border-0 btn-white btn-sm rounded-circle p-1 m-1 p-md-2' />
                <Card.Body className="qr-body p-0 m-0">
                    <Card.Title className='qr-code-title text-center text-white'>
                        Augmented Reality is only available on mobile or tablet devices:
                    </Card.Title>
                    <Card.Text className=' text-center text-white small fw-light m-1 m-lg-3'>
                        Supported devices: iPhone 6S+ & iPad 5+ on iOS 12+ and Android 8.0+ with ARCore 1.9 support 
                        <br />
                        Open this page with such a device to experience AR.
                    </Card.Text>
                    <div className='qr-code-container align-content-center p-2 p-md-3 my-2 my-lg-5 border-1' >
                        <QRCode size={512} className='qrcode-box' value={url} viewBox={`0 0 512 512`} />
                    </div>
                    
                    <Col xs={12} className='my-2 d-md-block d-lg-none text-center'>
                        <a href={url} target='_blank' className='text-white watch-now-button py-2 px-2'> 
                            <img src="Image\ar-icon.svg" className='open-ar-button text-white px-1' /> 
                            <small className=' fw-bold'> Open AR View !</small> 
                        </a>
                    </Col>

                    <Card.Title className='qr-code-title text-center text-white m-1'>
                        Open with QR Code: 
                    </Card.Title>

                    <Card.Text className=' text-center text-white small fw-light'>
                        Scan this code to open the model on your device, then, tap on the AR icon.										
                    </Card.Text>

                </Card.Body>
            </Card>
        </>
    )
}

export default ARPlayer